export default "__VITE_ASSET__35IvqyZ2__"